export const PRICE = {
  PERCENT: 'PERCENT',
  AMOUNT: 'AMOUNT',
};

export const PRICE_SERVER_TO_CLIENT_MAPPING = {
  PERCENT: 'Percent',
  AMOUNT: 'Amount',
};
